import type { ScoutToolPart } from "./message/scoutChatMessage";

export const PRESENT_SCOUT_PRO_UPSELL_TOOL_NAME = "present_scout_pro_upsell";

export type ScoutProUpsellCapability =
  | "customer_data_lookup"
  | "file_upload_or_analysis"
  | "private_documents"
  | "document_intelligence"
  | "insights"
  | "write_actions"
  | "other";

export type ScoutProUpsell = {
  upsellId: string;
  capability: ScoutProUpsellCapability;
  message: string;
};

const CAPABILITY_VALUES: ReadonlySet<ScoutProUpsellCapability> = new Set([
  "customer_data_lookup",
  "file_upload_or_analysis",
  "private_documents",
  "document_intelligence",
  "insights",
  "write_actions",
  "other",
]);

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function readString(value: Record<string, unknown>, key: string): string | undefined {
  const candidate = value[key];
  return typeof candidate === "string" ? candidate : undefined;
}

function readCapability(value: unknown): ScoutProUpsellCapability {
  if (typeof value === "string" && CAPABILITY_VALUES.has(value as ScoutProUpsellCapability)) {
    return value as ScoutProUpsellCapability;
  }
  return "other";
}

export function parseScoutProUpsell(output: unknown): ScoutProUpsell | null {
  if (!isRecord(output)) return null;
  if (output.kind !== "scout_pro_upsell") return null;
  const upsellId = readString(output, "upsellId");
  const message = readString(output, "message");
  if (!upsellId || !message) return null;
  return {
    upsellId,
    capability: readCapability(output.capability),
    message,
  };
}

export function isScoutProUpsellTool(toolPart: ScoutToolPart): boolean {
  return toolPart.toolName === PRESENT_SCOUT_PRO_UPSELL_TOOL_NAME;
}
